<template>
  <div class="BoxPartes">
    <div class="BoxPartes_header mb-3"
         :class="{'BoxPartes_header_error': errors_general}">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="BoxPartes_header_title">
            {{ propHeader }}
            <span v-if="errors_general">
              <IconSvg class="icon-error-campo"
                       icon="alert" />
              Há campos incorretos
            </span>
          </h2>
        </div>

        <div v-if="propTipo === 'CASAMENTO' && propHeader === 'Testemunhas'"
             class="no-gutters d-flex justify-content-end">
          <button class="btn btn-sm btn-primary "
                  @click="importTestemunha">
            <IconSvg class="icon--xs icons--white"
                     icon="copy" />
          </button>
        </div>
      </div>
    </div>

    <div class="BoxPartes_body">
      <BoxPartes v-for="(part, index) in partes"
                 :key="index"
                 :parte="part"
                 :prop-tipo="propTipo"
                 :prop-errors-carga="errors_general"
                 :prop-unique-parte="partes.length == 1"
                 @edit="editParte(part, index)"
                 @remove="remove(part, index)" />

      <button v-b-modal.addPartes
              class="btn btn-sm btn-outline-primary btn-block btn-add-parte mb-3"
              type="button"
              @click="modalAdd = true">
        <IconSvg class="icon-add mr-1"
                 icon="add" />
        Adicionar {{ propHeader.toLowerCase() }}
      </button>
    </div>

    <b-modal v-if="modalAdd"
             id="addPartes"
             ref="modalAddParte"
             modal-class="modalDeclar"
             header-class="modalParte_header"
             footer-class="modalParte_footer"
             body-class="modalDeclar_body"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="modalChanged">
      <div slot="modal-header"
           class="modalPartes w-100">
        Cadastro de Declarante e Testemunha
      </div>
      <div class="mt-3">
        <FormPartes :prop-parte="parte"
                    :prop-tipo="propTipo"
                    :prop-cartorio="propCartorio"
                    :prop-validate-declarante="!declarantes.length"
                    :prop-validate-tipos="!tiposPartes.length"
                    :show-declarante-input="propTipo == 'DECLARANTE'"
                    :data="data"
                    @DocumentoRemoved="documentoRemoved"
                    @changed="changed" />
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalDeclar_footer">
        <button id="btn-cancel-parte"
                class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button id="btn-submit-parte"
                class="btn btn-sm btn-primary"
                type="button"
                :disabled="!parte.pessoa.nome"
                @click="addParte">
          Cadastrar
        </button>
      </div>
    </b-modal>

    <b-modal v-if="modalEdit"
             id="editPartes"
             ref="modalEditParte"
             modal-class="modalEditParte"
             header-class="modalParte_header"
             footer-class="modalParte_footer"
             body-class="modalEditParte_body"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="modalChanged">
      <div slot="modal-header"
           class="modalPartes w-100">
        Cadastro de Declarante e Testemunha
      </div>
      <div class="mt-3">
        <FormPartes :prop-parte="parte"
                    :read-only="readOnly"
                    :prop-tipo="propTipo"
                    :prop-cartorio="propCartorio"
                    :prop-validate-declarante="propTipo == 'DECLARANTE' && tipo == 'DECLARANTE' && declarantes.length == 1"
                    :prop-validate-tipos="tiposPartes.length == 1 && !!parte.tipo"
                    :show-declarante-input="propTipo == 'DECLARANTE'"
                    :data="data"
                    @DocumentoRemoved="documentoRemoved"
                    @changed="changed" />
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalEditParte_footer">
        <button id="btn-cancel-parte"
                class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button id="btn-submit-parte"
                class="btn btn-sm btn-primary"
                type="button"
                :disabled="disabledCpfNome('atualizar')"
                @click="updateDeclarante">
          Atualizar
        </button>
      </div>
    </b-modal>

    <b-modal v-if="modalTestemunha"
             id="editPartes"
             ref="modalEditParte"
             modal-class="modalEditParte"
             header-class="modalParte_header"
             footer-class="modalParte_footer"
             body-class="modalEditParte_body"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="modalChanged">
      <div slot="modal-header"
           class="modalPartes w-100">
        Importação Testemunhas
      </div>

      <!--      <BoxPreRegistro-->
      <!--           :prop-resultados="preRegistroCasamento"-->
      <!--           @onCumprirTodos="$emit('onCumprirTodos')" />-->


      <div v-for="(resultado, index) in preRegistroCasamento"
           :key="`gerenciador_resultados_item_${ index }`"
           class="row no-gutters mb-2">
        <div class="col modalItens">
          <div class="row">
            <div class="col">
              <div class="GerenciadorResultadosItem--header pb-2 pt-1">
                <div class="row no-gutters mb-1">
                  <div class="col BoxParte_header p-2">
                    <h6 class="">
                      <span style="float: left;"
                            class="mt-2 pt-1">
                        <b-form-checkbox
                          :id="`selecionar_todos_registros_${ index }`"
                          v-model="selecionados"
                          :name="`selecionar_todos_registros_${ index }`"
                          :value="resultado[0].cpf" />
                      </span>
                      <label class="m-0 mt-1 ml-1 pt-1">
                        {{ resultado[0].nome }}
                        <div class="mt-1">
                          <small>CPF: </small>{{ resultado[0].cpf }}
                        </div>
                      </label>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="BoxParte_body px-3 py-2">
            <div class="row no-gutters align-items-center justify-content-between">
              <div class="col-10 d-inline-flex BoxParte_body_content">
                <div class="d-inline-block col-2">
                  <ul class="BoxParte_list">
                    <li class="BoxParte_list_item BoxParte_list_title">
                      Profissão
                    </li>

                    <li class="BoxParte_list_item">
                      <strong>{{ resultado[0].ocupacao_declarada ? resultado[0].ocupacao_declarada : 'Não informado' }}</strong>
                    </li>
                  </ul>
                </div>

                <div class="d-inline-block col-2">
                  <ul class="BoxParte_list">
                    <li class="BoxParte_list_item BoxParte_list_title">
                      Nacionalidade
                    </li>

                    <li class="BoxParte_list_item">
                      <strong>{{ resultado[0].nacionalidade ? resultado[0].nacionalidade : 'Não informado' }}</strong>
                    </li>
                  </ul>
                </div>


                <div class="d-inline-block col-2">
                  <ul class="BoxParte_list">
                    <li class="BoxParte_list_item BoxParte_list_title">
                      Estado Civil
                    </li>

                    <li class="BoxParte_list_item">
                      <strong>{{ resultado[0].estado_civil ? resultado[0].estado_civil : 'Não informado' }}</strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalEditParte_footer">
        <button id="btn-cancel-parte2"
                class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button id="btn-submit-part2"
                class="btn btn-sm btn-primary"
                type="button"
                :disabled="!selecionados.length"
                @click="addPadrinhos">
          Importar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import FormPartes from '../../Forms/FormPartes.vue'
  import BoxPartes from '@/components/SofiaRei/Obito/BoxPartes.vue'
  import PreRegistroService from "@/services/PreRegistroService"

  export default {
    name: 'Partes',
    components: { FormPartes, BoxPartes },
    props: {
      data: { type: Object },
      partes: { type: Array, default: ()=>[] },
      registroId: { type: [Number, String], default: ()=>"" },
      readOnly: { type: Boolean, default: () => false },
      propHeader: {
        type: String,
        default: () => "Declarante e testemunha"
      },
      propTipo: {
        type: String,
        default: () => "DECLARANTE"
      },
      propCartorio: {
        type: Object, default: () => { return {} }
      },
      propRegistro: {
        type: Array, default: () => []
      },
      propRegistroSalvo: {
        type: Array, default: () => []
      },
      propCorrecoes: {type: Object, default: () => ({})}
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        parte: {},
        declarantes: [],
        tipo: '',
        errors_general: false,
        modalAdd: false,
        modalEdit: false,
        modalTestemunha: false,
        tiposPartes: [],
        params: {
          ids: [],
          tipo: 'Padrinho'
        },
        preRegistroCasamento: [],
        selecionados: [],
      }
    },
    watch: {
      propCartorio () {
        this.init()
      },
      partes () {
        this.getPartesDeclarantes()
        this.getTiposPartes()
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      }
    },
    created () {
      this.init()
      this.getPartesDeclarantes()
      this.getTiposPartes()
    },
    mounted () {
      this.verifyErrorsCarga()
    },
    methods: {
      modalChanged () { this.init()},

      init () {
        this.parte = {
          pessoa: {
            documentos: [],
            nacionalidade_codigo: 76,
            nacionalidade: {
              nacionalidade_codigo: 76,
              nome: 'Brasil',
              nome_masculino: 'brasileiro',
              nome_feminino: 'brasileira'
            },
            endereco: {
              uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf : '',
              cidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade : '',
              ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge : null,
              atual: true
            }
          },
        }
        this.preRegistroCasamento = []
        switch (this.propTipo) {

        case 'OBITO':
          this.parte.tipo = 'DECLARANTE'
          break
        case 'HABILITACAO':
          this.parte.tipo = 'TESTEMUNHA'
          break
        case 'CASAMENTO':
          this.parte.tipo = 'TESTEMUNHA'
          break
        default:
          this.parte.tipo = null
          break
        }

        this.modalAdd = false
        this.modalEdit = false
        this.modalTestemunha = false
      },

      changed (data) {
        this.parte = { ...data }
        if (!this.partes.length) this.$emit('verifyParte', this.parte)
      },

      disabledCpfNome (action) {
        if (action === 'atualizar') {
          return this.propTipo == 'DECLARANTE' && this.tipo == 'DECLARANTE' && this.parte.tipo != 'DECLARANTE' && this.declarantes.length == 1
        } else if (action === 'incluir') {
          return this.propTipo == 'DECLARANTE' && this.parte.tipo != 'DECLARANTE'
        }
      },

      async addParte () {
        const nome = await this.$validator.validate('nomeParte')
        const tipos = await this.$validator.validate('tiposPartes')

        if (!nome || !tipos) return

        const invalid = await this.validateEndereco()

        if (!!invalid) return

        this.$validator.validate().then(resp => {
          if (resp) {
            if (!this.partes.length) this.deleteError(['DECLARANTE', 'PARTES', 'NOME DA PARTE'])

            if (this.registroId) {
              this.parte = { ...this.parte, registro_id: this.registroId }
            }

            this.$emit('ParteAdded', { ...this.parte })
            this.parte = this.parteS
            this.modalAdd = false
            this.init()
            this.getPartesDeclarantes()
            this.verifyFocus()
          }
        })
      },

      async updateDeclarante () {
        const nome = await this.$validator.validate('nomeParte')
        const tipos = await this.$validator.validate('tiposPartes')

        if (!nome || !tipos) return

        const invalid = await this.validateEndereco()

        if (!!invalid) return

        this.$validator.validate().then(resp => {
          if (resp) {
            if (this.registroId) {
              this.parte = { ...this.parte, registro_id: this.registroId }
            }

            this.deleteError(['DECLARANTE', 'PARTES', 'NOME DA PARTE'])
            this.$emit('ParteUpdated', { ...this.parte })
            this.modalEdit = false
            this.init()
            this.getPartesDeclarantes()
            this.verifyFocus()
          }
        })
      },

      editParte (parte, localId) {
        this.parte = { ...parte }

        if (this.registroId) {
          this.parte = { ...this.parte, registro_id: this.registroId }
        }

        this.tipo = parte.tipo

        this.parte = { ...parte }

        this.parte.localId = localId

        this.modalEdit = true
      },

      async remove (parte, localId) {
        const question = await Alerts.question(`Deseja excluir "${parte.pessoa.nome}"?`)
        if (question) {
          this.deleteError(['DECLARANTE', 'PARTES', 'NOME DA PARTE'])
          this.$emit('ParteRemoved', parte, localId)
          this.verifyFocus()
        }
      },

      async documentoRemoved (documento) {
        this.$emit('DocumentoRemoved', documento)
      },

      getPartesDeclarantes () {
        if (!this.partes.length) {
          this.declarantes = []
          return
        }

        this.declarantes = []

        this.partes.forEach((parte) => {
          if (parte.tipo == 'DECLARANTE') this.declarantes.push(parte)
        })
      },
      deleteError (error) {
        this.$emit('deleteError', error)
      },
      verifyErrorsCarga () {
        this.errors_general = false

        const errors = ['DECLARANTE', 'PARTES', 'NOME DA PARTE']

        Object.keys(this.propCorrecoes).forEach(key => {
          if (errors.indexOf(key) != -1) this.errors_general = true
        })
      },
      getTiposPartes () {
        if (!this.partes.length) {
          this.tiposPartes = []
          return
        }

        this.tiposPartes = []

        this.partes.forEach((parte) => {
          if (parte.tipo) this.tiposPartes.push(parte)
        })
      },
      verifyFocus () {
        const btnAddPartes = document.querySelector('.btn-add-parte')
        if (btnAddPartes) {
          setTimeout(() => {
            btnAddPartes.focus()
          }, 100)
        }
      },
      async validateEndereco () {
        const valid = await this.$validator.validate()

        const {errors: {items}} = this.$validator
        let emptyNumber = false

        if (items && items.length) {
          emptyNumber = !!items.find(item => item.field == 'numero' || item.field == 'codigo_ibge')
        }

        if (!valid || emptyNumber)  {
          return true
        } else {
          return false
        }
      },
      async importTestemunha () {
        try {
          loader({ active: true, text: 'Buscando Testemunhas...' })

          if ((this.propRegistro && this.propRegistro.length) || (this.propRegistroSalvo && this.propRegistroSalvo.length)) {
            this.params.ids = []

            if (this.propRegistro && this.propRegistro.length) {
              this.propRegistro.forEach((pessoa) => {
                if (pessoa.cpf) {
                  this.params.ids.push(pessoa.cpf.replace(/[^0-9]+/g,''))
                }
              })
            } else {
              this.propRegistroSalvo.forEach((pessoa) => {
                if (pessoa.cpf) {
                  this.params.ids.push(pessoa.cpf.replace(/[^0-9]+/g,''))
                }
              })
            }

            const { data } = await PreRegistroService.getPadrinhos(this.params)

            if (data && data.dados.padrinhos) {
              data.dados.padrinhos.forEach((informacoes, index) => {
                if (informacoes && informacoes.cpf) {
                  this.preRegistroCasamento[index] = [{
                    cpf: informacoes.cpf,
                    documentos: [{
                      codigo_orgao_emissor: 1,
                      data_emissao: informacoes.rg && informacoes.rg.dataExpedicao ? informacoes.rg.dataExpedicao : '',
                      numero: informacoes.rg ? informacoes.rg.numero : '',
                      tipo_documento: informacoes.rg ? 'RG' : '',
                      uf_emissor: informacoes.rg ? informacoes.rg.uf : ''
                    }],
                    endereco: {
                      atual: true,
                      bairro: informacoes.endereco ? informacoes.endereco.bairro : '',
                      cep: informacoes.endereco ? informacoes.endereco.cep : '',
                      cidade: informacoes.endereco ?  informacoes.endereco.localidade : '',
                      complemento: informacoes.endereco ?  informacoes.endereco.complemento : '',
                      logradouro: informacoes.endereco ?  informacoes.endereco.logradouro : '',
                      numero: informacoes.endereco ?  informacoes.endereco.numero : '',
                      uf: informacoes.endereco ?  informacoes.endereco.uf : ''
                    },
                    estado_civil: informacoes.estadoCivil ? informacoes.estadoCivil : '',
                    nome: informacoes.nome ? informacoes.nome : '',
                    ocupacao_declarada: informacoes.profissao ? informacoes.profissao : '',
                    data_nascimento: informacoes.dataNascimento ? informacoes.dataNascimento : '',
                    sexo: informacoes.sexo ? informacoes.sexo : '',
                  }]
                }
              })
            }
            this.modalTestemunha = true
          }

        } catch (e) {
          displayMessage('error', 'Atenção!', 'Erro ao buscar testemunhas. Tente novamente, caso o erro persistir, contate o suporte.')
        } finally {
          if (this.preRegistroCasamento && !this.preRegistroCasamento.length) {
            displayMessage('error', 'Atenção!', 'Testemunha(s) não encontrada(s). Tente novamente, caso o problema persistir, contate o suporte.')
            loader({ active: false, text: '' })
            this.modalTestemunha = false
          } else {
            loader({ active: false, text: '' })
          }
        }
      },

      async addPadrinhos () {
        this.$validator.validate().then(resp => {
          if (resp) {
            this.selecionados = this.preRegistroCasamento.filter(selecionado => this.selecionados.find(resultado => selecionado[0].cpf == resultado))
            if (this.selecionados) {
              this.selecionados.forEach((registro) => {
                this.parte.pessoa = {...this.parte.pessoa, ...registro[0]}
                this.$emit('ParteAdded', { ...this.parte })
              })
            }
            this.parte = this.parteS
            this.modalTestemunha = false
            this.init()
            this.getPartesDeclarantes()
            this.verifyFocus()
          }
        })
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

  .BoxPartes {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }

      &_error {
        color: #8B0000;
      }
    }
  }

  .modalDeclar {
    &_body {
      border-bottom: pxToRem(1) solid $sinoreg-blue;
      margin: 0 pxToRem(20);
      padding: 0;
    }

    &_footer {
      border: none;
    }

    .modal-footer {
      border: none;
    }
  }
  .modalPartes{
    background-color: #074f7f;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.625rem 1.25rem;
  }
  .modalParte{
    &_header {
      padding: 0 0;
    }

    &_footer {
      border: none;
    }
  }

  .btn-add-parte:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
  .modalItens{
    box-shadow: 2px 2px 4px #00000029;
  }
</style>
